<template>
  <dialog class="z-50 note-dialog" name="note" height="auto" id="note-dialog">
    <div class="dialog__content">
      <div class="w-full" @keydown.enter="save">
        <div class="w-full">
          <label class="block text-grey-darker font-bold mb-1 md:mb-0 pr-4" for="note">
            Deine Hinweise zu diesem Artikel
          </label>
        </div>
        <div class="w-full">
          <textarea v-model="note" maxlength="255" class="block appearance-none w-full h-24 bg-grey-lighter border border-grey-lighter text-grey-darker py-3 px-4 pr-8 rounded" id="note" placeholder=""></textarea>
        </div>
        <div class="w-full mt-4" :class="{ loading: isSaving }">
          <button @click.prevent="save" class="shadow bg-green-heinz hover:bg-green-heinz-light text-black font-bold py-2 px-4 rounded cursor-pointer" type="button">
            Weiter!
          </button>
        </div>
      </div>
    </div>
  </dialog>
</template>

<script>
import endpoints from '../endpoints'
import axios from 'axios'
import { mapActions } from 'vuex'
import { openDialog, closeDialog } from '../utils/dialog'

export default {
  name: 'Notecomponent',

  data () {
    return {
      basketId: null,
      note: '',
      isSaving: false
    }
  },

  created () {
    window.eventBus.$on('addNote', data => {
      this.basketId = parseInt(data.basketId)
      this.note = data.note
      openDialog('note-dialog')

      const isIE11 = (!!window.MSInputMethodContext && !!document.documentMode)
      if (!isIE11) {
        window.setTimeout(() => {
          document.getElementById('note').focus()
        }, 500)
      }
    })
  },

  methods: {
    ...mapActions([
      'updateBasket'
    ]),

    save: function () {
      if (this.isSaving) return
      this.isSaving = true

      axios.post(endpoints.note, {
        basketId: this.basketId,
        note: this.note
      })
        .then(response => {
          this.updateBasket()
          closeDialog('note-dialog')
          this.isSaving = false

          if (response.data.ingredientChangesCount && response.data.ingredientChangesCount > 0) {
            window.setTimeout(() => {
              alert('Wir haben in deinem Hinweis ' + response.data.ingredientChangesCount + ' Änderungen der Zutaten erkannt und entsprechend übernommen. Bitte prüfe zur Sicherheit, ob wir das richtig verstanden haben.')
            }, 50)
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Notecomponent.vue